import {
  CalculusEnum,
  EnamelEnum,
  FractureEnum,
  FurcationEnum,
  GingivitisEnum,
  MobilityEnum,
  PeriodontalEnum,
  ResorptionEnum,
  ToothStateEnum
} from "requests";
import { FormValues } from "./types";

export const EMPTY_FORM_VALUES: FormValues = {
  toothState: null,
  periodontal: null,
  furcation: null,
  mobility: null,
  gingivitis: null,
  calculus: null,
  enamel: null,
  fracture: null,
  resorption: null,
  other: [],

  periodontalPocketMBuc: null,
  periodontalPocketBuccal: null,
  periodontalPocketDBuc: null,
  periodontalPocketMLingPal: null,
  periodontalPocketLingPal: null,
  periodontalPocketDLingPal: null,

  gingivalRecessionMBuc: null,
  gingivalRecessionBuccal: null,
  gingivalRecessionDBuc: null,
  gingivalRecessionMLingPal: null,
  gingivalRecessionLingPal: null,
  gingivalRecessionDLingPal: null
};

export const TOOTH_STATE_OPTIONS = [
  { value: ToothStateEnum.Extracted, label: "Extracted" },
  { value: ToothStateEnum.Missing, label: "Missing" },
  { value: ToothStateEnum.Abnormal, label: "Abnormal" },
  { value: ToothStateEnum.Untreated, label: "Untreated" },
  { value: ToothStateEnum.Treated, label: "Treated" },
  { value: ToothStateEnum.Unerupted, label: "Unerupted" }
];

export const PERIODONTAL_OPTIONS = [
  { value: PeriodontalEnum.Pd1, label: "PD1" },
  { value: PeriodontalEnum.Pd2, label: "PD2" },
  { value: PeriodontalEnum.Pd3, label: "PD3" },
  { value: PeriodontalEnum.Pd4, label: "PD4" }
];

export const FURCATION_OPTIONS = [
  { value: FurcationEnum.F1, label: "F1" },
  { value: FurcationEnum.F2, label: "F2" },
  { value: FurcationEnum.F3, label: "F3" }
];

export const MOBILITY_OPTIONS = [
  { value: MobilityEnum.M1, label: "M1" },
  { value: MobilityEnum.M2, label: "M2" },
  { value: MobilityEnum.M3, label: "M3" }
];

export const GINGIVITIS_OPTIONS = [
  { value: GingivitisEnum.Gi1, label: "GI1" },
  { value: GingivitisEnum.Gi2, label: "GI2" },
  { value: GingivitisEnum.Gi3, label: "GI3" }
];

export const CALCULUS_OPTIONS = [
  { value: CalculusEnum.C1, label: "C1" },
  { value: CalculusEnum.C2, label: "C2" },
  { value: CalculusEnum.C3, label: "C3" }
];

export const ENAMEL_OPTIONS = [
  { value: EnamelEnum.Ab, label: "AB" },
  { value: EnamelEnum.At, label: "AT" },
  { value: EnamelEnum.Ca, label: "CA" },
  { value: EnamelEnum.ED, label: "E/D" },
  { value: EnamelEnum.EH, label: "E/H" },
  { value: EnamelEnum.EHm, label: "E/HM" }
];

export const FRACTURE_OPTIONS = [
  { value: FractureEnum.TFxEi, label: "T/FX/EI" },
  { value: FractureEnum.TFxEf, label: "T/FX/EF" },
  { value: FractureEnum.TFxUcf, label: "T/FX/UCF" },
  { value: FractureEnum.TFxCcf, label: "T/FX/CCF" },
  { value: FractureEnum.TFxUcrf, label: "T/FX/UCRF" },
  { value: FractureEnum.TFxCcrf, label: "T/FX/CCRF" },
  { value: FractureEnum.TFxRf, label: "T/FX/RF" }
];

export const RESORPTION_OPTIONS = [
  { value: ResorptionEnum.Tr1, label: "TR1" },
  { value: ResorptionEnum.Tr2, label: "TR2" },
  { value: ResorptionEnum.Tr3, label: "TR3" },
  { value: ResorptionEnum.Tr4, label: "TR4" },
  { value: ResorptionEnum.Tr5, label: "TR5" }
];
